import Vue from 'vue'

export const notificationStore = {
  namespaced: true,
  state: {},
  actions: {
    pushNotification({ commit }, notification) {
      Vue.notify({ clean: true })
      setTimeout(() => {
        commit('DISPLAY_NOTIFICATION', notification)
      }, 500)
    }
  },
  mutations: {
    DISPLAY_NOTIFICATION(state, notification) {
      let notificationMessage = {}

      switch (notification.type) {
        case 'error':
          notificationMessage = {
            title: 'Please review the following error(s):',
            data: {
              icon: 'error-icon',
              classType: 'error',
              messages: []
            },
            duration: 10000
          }
          notificationMessage.data.messages = notification.messages
          Vue.notify({ ...notificationMessage })
          break
        case 'success':
          notificationMessage = {
            title: notification.title || 'Success',
            data: {
              icon: 'check-icon',
              classType: 'success',
              messages: []
            },
            duration: 10000
          }
          notificationMessage.data.messages = notification.messages
          Vue.notify({ ...notificationMessage })
          break
        case 'info':
          notificationMessage = {
            title: 'Info',
            data: {
              icon: 'info-icon',
              classType: 'info',
              messages: []
            },
            duration: 10000
          }
          notificationMessage.data.messages = notification.messages
          Vue.notify({ ...notificationMessage })
          break

        case 'warning':
          notificationMessage = {
            title: 'Warning',
            data: {
              icon: 'warning-icon',
              classType: 'warning',
              messages: []
            },
            duration: 10000
          }
          notificationMessage.data.messages = notification.messages
          Vue.notify({ ...notificationMessage })
          break
        default:
          break
      }
    }
  }
}
